export const paymentConfig = {
  couponCodeMaxLength: "12",
  minRechargeAmtINR: 500.0,
  minRechargeAmtUSD: 20,
  rechargeGST: 18,
  subscriptionGST: 18,
  minCoinsForWarning: 50000,
};
